import { render, staticRenderFns } from "./MetricDetails.vue?vue&type=template&id=67e47890"
import script from "./MetricDetails.vue?vue&type=script&lang=js"
export * from "./MetricDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports